const headTableCell = [
	{ id: 1, property: '', label: '' },
	{ id: 2, property: 'firstName', label: 'First name' },
	{ id: 3, property: 'lastName', label: 'Last name' },
	{ id: 4, property: 'phone', label: 'Work phone' },
	{ id: 5, property: 'email', label: 'Work Email' },
	{ id: 6, property: 'username', label: 'Username' },
	{ id: 7, property: 'custName', label: 'Master Company' },
	{ id: 8, property: 'isEnabled', label: 'Is enabled' },
];

export default headTableCell;
